// extracted by mini-css-extract-plugin
export var billingAddress = "_rj-g";
export var contactInfo = "_rj-d";
export var customerInfoContainer = "_rj-c";
export var customerInfoContainerMobile = "_rj-h";
export var customerInfoRow = "_rj-a";
export var customerInfoSection = "_rj-b";
export var fullWidthDividerMobile = "_rj-i";
export var imageContainer = "_rj-1";
export var paymentMethod = "_rj-e";
export var priceText = "_rj-6";
export var priceTextMobile = "_rj-7";
export var product = "_rj-0";
export var productImage = "_rj-2";
export var productInfo = "_rj-4";
export var productMobile = "_rj-9";
export var productTitle = "_rj-8";
export var quantityBadge = "_rj-3";
export var quantityText = "_rj-5";
export var shippingAddress = "_rj-f";